import React, { Fragment } from 'react';
import { observer } from 'mobx-react';
import { http } from '../../services/HttpInterceptor';
import {
    RouteComponentProps, Link, Redirect
} from "react-router-dom";
import { toast } from 'react-toastify';
import { observable } from 'mobx';
import InputForm from '../site/layout/InputForm';

interface EditMobilePaymentProps extends RouteComponentProps {
    changeToggle(action?: boolean): void
}

@observer export default class EditMobilePayment extends React.Component<EditMobilePaymentProps> {

    @observable private mobilePayment: any;
    @observable private isLoaded = false;
    @observable private redirect = false;
    @observable private validationErrors: string[] = [];
    @observable private activeOptions = [
        { value: 0, label: 'Habilitado' },
        { value: 1, label: 'Deshabilitado' }
    ];

    componentDidMount() {
        this.props.changeToggle(true);
        this.init();
    }

    init = () => {
        const match = this.props.match;
        const id = (match as any).params.id;
        http.get(`/api/mobile_payments/read/${id}`).then((response) => {
            this.mobilePayment = response.data;
            this.isLoaded = true;
        })
            .catch((error) => {
                toast.error("Error cargando método de pago móvil");
            });
    }

    private handleChange = (event: any) => {
        const { name, value } = event.target;
        this.mobilePayment[name] = value;
    }

    private setValidation = (value: boolean, name: string): void => {
        const error = this.validationErrors.indexOf(name);
        if (value && error === -1) {
            this.validationErrors.push(name);
        } else if (!value && error !== -1) {
            this.validationErrors.splice(error, 1);
        }
    }

    private onSubmit = (): void => {

        if (this.validationErrors.length > 0) {
            toast.error("Hay un error en tu formulario");
            return;
        }

        http.post(`/api/mobile_payments/update`, JSON.stringify(this.mobilePayment))
            .then(() => {
                toast.success(`Método de pago móvil actualizado`);
                this.redirect = true;
            }).catch((error) => {
                if (Array.isArray(error)) {
                    error.forEach((val) => {
                        toast.error(val);
                    })
                } else {
                    toast.error(error);
                }
            });
    }


    render() {
        if (!this.isLoaded) {
            return null;
        }
        if (this.redirect) {
            return <Redirect to="/pagos-movil" />
        }
        return (
            <Fragment>
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-header card-header-rose card-header-text">
                                <div className="card-text">
                                    <h4 className="card-title">Editar Método de Pago Móvil: {this.mobilePayment?.name}</h4>
                                </div>
                            </div>
                            <div className="card-body ">
                                <div className="row">
                                    <div className="col-sm-10"></div>
                                    <div className="col-sm-2">
                                        <Link to={`/pagos-movil`}>
                                            <button className="btn btn-danger btn-sm  pull-right">
                                                <i className="material-icons">highlight_off</i>
                                                <div className="ripple-container"></div>
                                            </button>
                                        </Link>
                                    </div>
                                </div>
                                <InputForm
                                    name="name"
                                    label="Nombre del Método de Pago"
                                    value={this.mobilePayment?.name || ""}
                                    setValidation={this.setValidation}
                                    required={true}
                                    onChange={this.handleChange}
                                    type="text"
                                />
                                <div className="row">
                                    <label className="col-sm-2 col-form-label">Descripción</label>
                                    <div className="col-sm-10">
                                        <div className="form-group bmd-form-group">
                                            <textarea
                                                className="form-control"
                                                name="description"
                                                rows={4}
                                                value={this.mobilePayment?.description || ""}
                                                onChange={this.handleChange}
                                                placeholder="Ej: Depósito a tarjeta 1234 5678 9012 3456, Banco XYZ, CLABE: 123456789012345678"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <label className="col-sm-2 col-form-label">Estado</label>
                                    <div className="col-sm-10">
                                        <div className="form-group bmd-form-group is-filled">
                                            <select
                                                className="form-control"
                                                name="disabled"
                                                value={this.mobilePayment?.disabled || 0}
                                                onChange={this.handleChange}
                                            >
                                                {this.activeOptions.map((option) => (
                                                    <option key={option.value} value={option.value}>
                                                        {option.label}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <button onClick={this.onSubmit} type="submit" className="btn btn-primary pull-right">Actualizar Método de Pago</button>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment >
        )
    }
}

